var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWreathFlowerBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2515 22.7799C18.2515 22.7799 22.9509 19.9371 26 24.5712C26 24.5712 23.0025 28.4826 19.4366 26.7358",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7485 20.6221C13.7485 20.6221 8.94574 17.7861 6 22.3381C6 22.3381 9.59001 26.4242 12.5116 24.5506",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 18.978V31",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9949 28.414C15.9949 28.414 16.4428 24.345 21.1422 24.5539",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9949 25.996C15.9949 25.996 15.5471 21.927 10.8477 22.136L15.9949 25.996Z",
    fill: "#0186B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9949 25.996C15.9949 25.996 15.5471 21.927 10.8477 22.136",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2756 6.4423C13.8139 2.63706 15.9948 2 15.9948 2C15.9948 2 18.1757 2.63706 17.714 6.44573",
    fill: "#0186B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2756 6.4423C13.8139 2.63706 15.9948 2 15.9948 2C15.9948 2 18.1757 2.63706 17.714 6.44573",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8775 8.8502C8.84221 6.48348 9.93093 4.50037 9.93093 4.50037C9.93093 4.50037 11.9258 3.41805 14.3065 6.43553",
    fill: "#0186B5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8775 8.8502C8.84221 6.48348 9.93093 4.50037 9.93093 4.50037C9.93093 4.50037 11.9258 3.41805 14.3065 6.43553",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8948 12.234C8.0671 12.6929 7.42627 10.5249 7.42627 10.5249C7.42627 10.5249 8.0671 8.35679 11.8983 8.81574",
    fill: "#0186B5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8948 12.234C8.0671 12.6929 7.42627 10.5249 7.42627 10.5249C7.42627 10.5249 8.0671 8.35679 11.8983 8.81574",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.317 14.618C11.9363 17.6355 9.94143 16.5532 9.94143 16.5532C9.94143 16.5532 8.85271 14.5701 11.888 12.2034",
    fill: "#0186B5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.317 14.618C11.9363 17.6355 9.94143 16.5532 9.94143 16.5532C9.94143 16.5532 8.85271 14.5701 11.888 12.2034",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7208 14.6008C18.1825 18.4061 16.0016 19.0431 16.0016 19.0431C16.0016 19.0431 13.8208 18.4061 14.2824 14.5974",
    fill: "#0186B5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7208 14.6008C18.1825 18.4061 16.0016 19.0431 16.0016 19.0431C16.0016 19.0431 13.8208 18.4061 14.2824 14.5974",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1189 12.1965C23.1542 14.5633 22.0655 16.5464 22.0655 16.5464C22.0655 16.5464 20.0706 17.6287 17.6899 14.6112",
    fill: "#0186B5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1189 12.1965C23.1542 14.5633 22.0655 16.5464 22.0655 16.5464C22.0655 16.5464 20.0706 17.6287 17.6899 14.6112",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1016 8.80915C23.9293 8.35019 24.5701 10.5183 24.5701 10.5183C24.5701 10.5183 23.9293 12.6863 20.0981 12.2274",
    fill: "#0186B5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1016 8.80915C23.9293 8.35019 24.5702 10.5183 24.5702 10.5183C24.5702 10.5183 23.9293 12.6863 20.0981 12.2274",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6829 6.4287C20.0636 3.41122 22.0584 4.49354 22.0584 4.49354C22.0584 4.49354 23.1471 6.47665 20.1118 8.84336",
    fill: "#0186B5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6829 6.4287C20.0636 3.41122 22.0584 4.49354 22.0584 4.49354C22.0584 4.49354 23.1471 6.47665 20.1118 8.84336",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9982 12.2238C16.9439 12.2238 17.7105 11.4617 17.7105 10.5216C17.7105 9.58146 16.9439 8.81934 15.9982 8.81934C15.0525 8.81934 14.2859 9.58146 14.2859 10.5216C14.2859 11.4617 15.0525 12.2238 15.9982 12.2238Z",
    fill: "white",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWreathFlowerBlue);
export default __webpack_public_path__ + "static/media/icon-wreath-flower-blue.ee35fadcc86bd1b341d6f44e060358f6.svg";
export { ForwardRef as ReactComponent };